export const payment_methods = {
  COD: 'cash_on_delivery',
  JUSPAY: 'juspay',
}
